import {ComponentRef, Injectable, ViewContainerRef} from "@angular/core";
import {FUISpinnerComponent} from "./spinner/spinner.component";
import {delay, Observable} from "rxjs";

@Injectable()
export class FUISpinnersService {
    public placeholder: ViewContainerRef;
    public spinner: ComponentRef<FUISpinnerComponent>;

    /**
     *
     * @param delayMs
     */
    create(delayMs: number = 250): Observable<FUISpinnerComponent> {
        this.spinner = this.placeholder.createComponent(FUISpinnerComponent)
        return new Observable<FUISpinnerComponent>((observer) => {
            observer.next(this.spinner.instance);
            observer.complete();
        }).pipe(delay(delayMs));
    }

    /**
     * Remove the component from the DOM
     * @param instance
     */
    destroy(instance: FUISpinnerComponent): Observable<void> {
        this.spinner.destroy();

        return new Observable<void>((observer) => {
            /**
             * Return an empty instance of an alert
             * to allow clearing at the client of the
             * created instance.
             */
            observer.next();
            observer.complete();
        })
    }

    /**
     *
     * @param modal
     * @param delayMs
     * @returns {any}
     */
    open(modal: boolean = true, delayMs: number = 250): Observable<FUISpinnerComponent> {
        setTimeout(() => {
            this.spinner.instance.active = true;
            this.spinner.instance.modal = modal;
        });

        return new Observable<FUISpinnerComponent>((observer) => {
            observer.next(this.spinner.instance);
            observer.complete();
        }).pipe(delay(delayMs));
    }

    /**
     *
     * @returns {any}
     * @param delayMs
     */
    close(delayMs: number = 250): Observable<FUISpinnerComponent> {
        setTimeout(() => {
            this.spinner.instance.active = false;
        });

        /**
         * Returning an observable so that actions can be performed
         * in an order - close and then destroy, for instance
         */
        return new Observable<FUISpinnerComponent>((observer) => {
            observer.next(this.spinner.instance);
            observer.complete();
        }).pipe(delay(delayMs));
    }

    /**
     *
     * @param viewContainerRef
     */
    setPlaceholder(viewContainerRef: ViewContainerRef) {
        this.placeholder = viewContainerRef;
    }

    isOpen(): boolean {
        return this.spinner && this.spinner.instance && this.spinner.instance.active;
    }
}
